import React, { useEffect } from 'react';
import type { ReactNode } from 'react';
import useStyles from '../../theme/useStyles';

// Centred dialog with a purple header bar, click-outside and Esc to close.
export interface ModalProps {
  open?: boolean;
  title?: ReactNode;
  onClose?: () => void;
  footer?: ReactNode;
  width?: string;
  closeOnOverlay?: boolean;
  children?: ReactNode;
  isDarkMode?: boolean;
}

const Modal = ({
  open = true,
  title,
  onClose,
  footer,
  width = '500px',
  closeOnOverlay = true,
  children,
  isDarkMode
}: ModalProps) => {
  const s = useStyles(isDarkMode);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div style={s.drawerOverlay} onClick={closeOnOverlay ? onClose : undefined}>
      <div
        style={{ ...s.drawerPanel, maxWidth: width }}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        {(title || onClose) && (
          <div style={s.drawerHeader}>
            <h2 style={{ ...s.drawerTitle, fontSize: s.t.fontSize.xl }}>{title}</h2>
            {onClose && <button style={s.drawerCloseBtn} onClick={onClose} aria-label="Close">✕</button>}
          </div>
        )}
        <div style={{ ...s.drawerBody, padding: s.t.spacing.xl }}>{children}</div>
        {footer && <div style={s.drawerFooter}>{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
